// NationalitySelect.tsx

import React from "react";
import { COUNTRIES } from "../../constants/countries";
import { useLanguage } from "../../context/LanguageContext";

interface Props
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  value: string;
  label?: string;
  error?: string;
}

export default function NationalitySelect({
  value,
  onChange,
  className = "",
  name = "nationality",
  id,
  label,
  required = false,
  error,
  ...props
}: Props) {
  const { t } = useLanguage();
  const resolvedLabel = label ?? t("talentProfile.attrs.nationality");
  const selectId = id || name;

  return (
    <div>
      <label
        htmlFor={selectId}
        className="flex items-center text-sm font-medium text-gray-700 mb-2"
      >
        {resolvedLabel}

        {required && (
          <span className="text-red-500 ms-1">
            *
          </span>
        )}
      </label>

      <select
        {...props}
        id={selectId}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        aria-invalid={!!error}
        autoComplete="country-name"
        className={`
          w-full px-4 py-3
          border rounded-xl
          text-sm
          transition-all
          focus:outline-none
          focus:ring-2
          focus:ring-[#b3d130]/20
          focus:border-[#b3d130]
          ${error
            ? "border-red-500 bg-red-50"
            : "border-gray-300"
          }
          ${className}
        `}
      >
        <option value="">
          {t("nationalitySelect.selectPlaceholder")}
        </option>

        {COUNTRIES.map((country) => (
          <option
            key={country}
            value={country}
          >
            {country}
          </option>
        ))}
      </select>

      {error && (
        <p className="text-xs text-red-500 mt-1">
          ⚠️ {error}
        </p>
      )}
    </div>
  );
}